module.exports = __webpack_public_path__ + "static/testExec-7613231b0ef1a71281a45958641c2022.svg";